import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue';
import { crcService } from './crc';
import { useAuthStore } from '../stores/auth';
const baseUrl = `${import.meta.env.VITE_API_URL}`;
const permissao = ref(null);

const authService = {
  verifyAndUpdateToken: () => {
    return fetchWrapper.get(`${baseUrl}/verify-and-update-token`, null, null);
  },
  getSelfData: () => {
    return fetchWrapper.get(`${baseUrl}/get-own-data`, null, null, null);
  },
  async getPermissao() {
    try{
      const authStore = useAuthStore();
      if(authStore.user.cpf){
        const jsonBusca = {
          "cpf_usuario": authStore.user.cpf
        }
        /*const [dados] = await Promise.all([
          crcService.getModulo(jsonBusca)
        ]);*/
        const response = await crcService.getModulo(jsonBusca);
        permissao.value = response.data;
        return permissao.value;
      }else{
        return permissao.value = 0;
      } 
    } catch (error){
      console.error('Erro ao buscar permissão:', error);
      throw error;
    }
  }
};

export default authService;
